import { z } from 'zod'
import { api } from '@/shared/api/client'

export const MENU_MODULES = ['VENUES', 'STOCK', 'PEOPLE', 'CRM', 'NOTIFICATIONS', 'STAKEHOLDERS', 'SUPPLIERS'] as const
export type MenuModule = (typeof MENU_MODULES)[number]

/** Tashkilot sozlamasida yashirilishi mumkin bo'lgan bo'lim → menyu guruhi yoki bandlari */
export const MENU_MODULE_ENTRIES: Readonly<Record<MenuModule, { groups?: readonly string[]; paths?: readonly string[] }>> = {
  VENUES: { groups: ['venue'] },
  STOCK: { groups: ['stock'] },
  PEOPLE: { groups: ['hr'] },
  CRM: { groups: ['crm'] },
  NOTIFICATIONS: { groups: ['notify'] },
  STAKEHOLDERS: { paths: ['/finance/stakeholders', '/finance/stakeholder-distributions'] },
  SUPPLIERS: { paths: ['/suppliers', '/purchases'] },
}

const menuSchema = z.object({ hiddenModules: z.array(z.string()) })

function known(modules: readonly string[]): MenuModule[] {
  return modules.filter((m): m is MenuModule => (MENU_MODULES as readonly string[]).includes(m))
}

/** Tashkilot ishlatmaydigan bo'limlar — menyudan yashiriladi; har xodim o'qiydi */
export async function fetchHiddenModules(signal?: AbortSignal): Promise<MenuModule[]> {
  const response = await api.get<unknown>('/api/tenant-settings/menu', { ...(signal ? { signal } : {}) })
  return known(menuSchema.parse(response.data).hiddenModules)
}

export async function saveHiddenModules(modules: readonly MenuModule[]): Promise<MenuModule[]> {
  const response = await api.put<unknown>('/api/tenant-settings/menu', { hiddenModules: modules })
  return known(menuSchema.parse(response.data).hiddenModules)
}
